import { render, staticRenderFns } from "./JobTasks.vue?vue&type=template&id=0681bf57&"
import script from "./JobTasks.vue?vue&type=script&lang=js&"
export * from "./JobTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports